import { render, staticRenderFns } from "./ClientsAccess.vue?vue&type=template&id=26ba0e1e&scoped=true"
import script from "./ClientsAccess.vue?vue&type=script&lang=js"
export * from "./ClientsAccess.vue?vue&type=script&lang=js"
import style0 from "./ClientsAccess.vue?vue&type=style&index=0&id=26ba0e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ba0e1e",
  null
  
)

export default component.exports